import layout from "./default/LayoutConfig";

const themeLayoutConfigs = {
  layout,
};

export default themeLayoutConfigs;
